module.exports = __webpack_public_path__ + "img/load.e6d94d2f.svg";